/**
 * Shared helper for resolving Competitors-mode entity sets from filter inputs.
 *
 * Single source of truth so the workspace worker handlers and the API
 * overview endpoint resolve the "my brand" entity keys identically (no inline
 * drift).
 */

/**
 * Resolve the BQ `competitor` keys representing "you" (my brand).
 *
 * Falls back to the tenant's `default_brand` when no explicit filter is set.
 * `default_brand` may be a comma-joined list, so we split it the same way the
 * legacy Retool SQL does (`competitor IN UNNEST(SPLIT(..., ','))`).
 */
export function resolveMyBrandBqKeys(
  filterMyBrand: string | null,
  defaultBrand: string | null | undefined,
): string[] {
  const source = filterMyBrand ?? defaultBrand ?? null;
  if (!source) return [];
  return source.split(',').map((p) => p.trim()).filter(Boolean);
}
